var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12969 4.48639C8.72111 1.89497 12.9172 1.89497 15.5086 4.48639C18.1 7.0778 18.1 11.2739 15.5086 13.8653C12.9172 16.4567 8.72111 16.4567 6.12969 13.8653C3.53828 11.2739 3.53828 7.0778 6.12969 4.48639ZM0 18.196L1.80402 20L5.29745 16.5066C8.88058 19.2325 14.0235 18.9634 17.3127 15.6743C20.8958 12.0912 20.8958 6.27546 17.3127 2.68735C13.7295 -0.895783 7.91378 -0.895783 4.32567 2.68735C1.03657 5.97645 0.74254 11.0945 3.49343 14.6976L0 18.196Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.e16fc8b5a0c952f390b5aa0e4da3bd33.svg";
export { ForwardRef as ReactComponent };